export default __webpack_public_path__ + "static/media/logo_nobre.703ef2b4.png";